import React from 'react'
import { useMediaQuery } from 'react-responsive'

const AuthLayout = ({ title, subtitle, children, bannerTitle, bannerPoints, bannerTags }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 1024px)' })

    return (
        <div className="loginCnt">
            <div className="loginLeftCnt">
                <div className="loginTextCnt">
                    <div className="lognBannerTitle">
                        <h2>{bannerTitle}</h2>
                        <span className="d-block text-left">{subtitle}</span>
                    </div>
                    <div className="d-flex flex-column align-items-start mobShowHide">
                        <div className="loginPoints d-flex flex-column align-items-start">
                            {bannerPoints.map((point, index) => (
                                <div key={index}>
                                    <img src="/assets/images/check-icon.png" />
                                    <span>{point}</span>
                                </div>
                            ))}
                        </div>
                        <div className="pointers">
                            {bannerTags.map((tag, index) => (
                                <span key={index}>{tag}</span>
                            ))}
                        </div>
                    </div>
                </div>
                {isMobile && <div className="login">{children}</div>}
                <img className="btmImage" src="/assets/images/right-btm-img.png" />
            </div>

            {!isMobile && <div className="login">{children}</div>}
        </div>
    )
}

export default AuthLayout
